import React, { useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { showLabelsInsidePlugin } from "./chartJsPlugins";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  showLabelsInsidePlugin
);

function DutyAndTaxMovementHorizontalChart({ title, liabilities }) {
  const getOptions = (title) => ({
    indexAxis: "y", // This makes the bar chart horizontal
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          color: "#9ca3af", // Muted text for legend
          font: {
            size: 12,
            family: "'Inter', sans-serif",
          },
          usePointStyle: true,
          pointStyle: 'circle',
        },
      },

      title: {
        display: true,
        color: "#f3f4f6", // Light text for title
        text: title,
        align: 'start',
        padding: {
          bottom: 20
        },
        font: {
          size: 18,
          weight: '600',
          family: "'Inter', sans-serif",
        },
      },
      tooltip: {
        backgroundColor: 'rgba(17, 24, 39, 0.9)', // Dark tooltip bg
        titleColor: '#f3f4f6',
        bodyColor: '#d1d5db',
        borderColor: '#374151',
        borderWidth: 1,
        padding: 10,
        boxPadding: 4,
        cornerRadius: 8,
      }
    },
    scales: {
      x: {
        stacked: false,
        beginAtZero: true,
        grid: {
          color: '#374151', // Dark grid lines
          borderDash: [5, 5],
          borderColor: 'transparent',
        },
        ticks: {
          callback: function (value) {
            return value / 1000 + "k"; // Scale by 1000 and add "k"
          },
          color: "#9ca3af", // Muted tick labels
          font: {
            family: "'Inter', sans-serif",
          },
        },
      },
      y: {
        stacked: true,
        grid: {
          display: false, // Hide y-axis grid
          borderColor: 'transparent',
        },
        ticks: {
          color: "#9ca3af",
          font: {
            size: 14,
            family: "'Inter', sans-serif",
          },
        },
      },
    },
  });

  const data = {
    // labels: ["Guarantee", "Liability", "VAT"],
    labels: ["Guarantee", "VAT"],

    datasets: [
      {
        label: "Current Value",
        data: [
          liabilities?.guaranteeValue - liabilities?.availableGuaranteeValue,
          // liabilities?.netLiability,
          liabilities?.totalReceiptVatAmount,
        ],
        barPercentage: 0.6,
        categoryPercentage: 0.7,
        barThickness: 20,
        borderRadius: 10, // Rounded corners
        backgroundColor: "#3b82f6", // Vibrant Blue
        hoverBackgroundColor: "#60a5fa",
        borderWidth: 0,
      },

      {
        label: "Net value",
        data: [
          liabilities?.guaranteeValue ?? 0,
          liabilities?.netLiability +
            liabilities?.totalExportPendingCanselitationLiability,
          0,
          0,
          0,
          0,
          // liabilities?.totalReceiptVatAmount ?? 0,
        ],
        barPercentage: 0.6,
        categoryPercentage: 0.7,
        barThickness: 20,
        borderRadius: 10,
        backgroundColor: "#10b981", // Vibrant Green
        hoverBackgroundColor: "#34d399",
        borderWidth: 0,
      },
    ],
  };

  return (
    <Bar
      data={data}
      options={getOptions(title)}
      style={{ height: "100%", minHeight: "300px", width: "100%" }}
    ></Bar>
  );
}

export default DutyAndTaxMovementHorizontalChart;
